import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import configurationReducer from '../modules/configuration/reducers';
import accountConnectorReducer from '../modules/account-connector/reducers';
import proofOfOwnershipMobileReducer from '../modules/account-connector/components/proof-of-ownership-mobile/reducers';

export default function configureStore(history, initialState) {
  const reducers = {
    configuration: configurationReducer,
    accountConnector: accountConnectorReducer,
    proofOfOwnershipMobile: proofOfOwnershipMobileReducer
  };

  const middleware = [
    thunk,
    routerMiddleware(history)
  ];

  // In development, use the browser's Redux dev tools extension if installed
  const enhancers = [];
  const isDevelopment = process.env.NODE_ENV === 'development';
  if (isDevelopment && typeof window !== 'undefined' && window.devToolsExtension) {
    enhancers.push(window.devToolsExtension());
  }

  const rootReducer = combineReducers({
    ...reducers,
    routing: routerReducer
  });

  return createStore(
    rootReducer,    
    initialState,
    compose(applyMiddleware(...middleware), ...enhancers)
  );
};


// WEBPACK FOOTER //
// ./src/store/configureStore.js